import { Message } from "primereact/message";

interface TeacherScheduleProps {
  teacherId?: number;
}

const TeacherSchedule = ({ teacherId }: TeacherScheduleProps) => {
  if (!teacherId) {
    return (
      <Message 
        severity="info" 
        text="Моля, първо запазете основните данни на преподавателя." 
        className="w-full my-4" 
      />
    );
  }

  return (
    <div className="card mt-4">
      <h2>График на преподавател</h2>
      <Message 
        severity="info" 
        text="Секцията е в процес на разработка." 
        className="w-full my-4" 
      />
    </div>
  );
};

export default TeacherSchedule; 